
import { defineComponent, ref } from "vue";
import DeliveryDetails from "@/components/DeliveryDetails.vue";
import NextStepButton from "@/components/NextStepButton.vue";
import ForgotPassword from "@/components/ForgotPassword.vue";
import PaymentDetails from "@/components/PaymentDetails.vue";

export default defineComponent({
  name: "DeliveryPaymentView",
  components: {
    DeliveryDetails,
    NextStepButton,
    ForgotPassword,
    PaymentDetails,
  },
  props: {
    isAuthed: {
      type: Boolean,
      default: false,
    },
    isDIY: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const page = ref("delivery");
    const hasAuth = ref(props.isAuthed);
    const goToPayment = () => {
      page.value = "payment";
    };
    return {
      page,
      goToPayment,
      hasAuth,
    };
  },
});
